import { Component } from "solid-js";

const CookiePolicy: Component = () => {
  return (
    <>
      <h1 class="text-xl">Cookie Policy</h1>
      <p>...</p>
    </>
  );
};

export default CookiePolicy;
